import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { BailModel } from './bail.model';
import { EventEmitter } from '@angular/core';
import { Output, AfterContentChecked } from '@angular/core';
import { ContactModel } from '../../contact/contact/contact.model';
import { ContactService } from '../../contact/contact/contact.service';
import { UntypedFormControl } from '@angular/forms';
import { map, Observable } from "rxjs";
import { BailLineModel } from './bail-line.model';
import { BailTaxModel } from './bail-tax.model';
import { InvoiceTaxesModel } from '../../invoice/preinvoice/invoicetaxes.model';
import { AccountsAndTaxesModel } from '../../invoice/preinvoice/accountsandtaxes.model';
import { ConceptModel } from '../../concept/concept/concept.model';
import { TaxCalculator } from '../../../shared/taxCalculator';
import { ActualSelected, Utils } from '../../../shared/utils';
import { consts, PAY_METHODS } from '../../../consts';
import { BankAccountModel } from '../../finanzas/bancos/bankaccount.model';
import { PaymentCardModel } from '../../finanzas/paymentcard/paymentcard.model';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Efectivo } from '../../../models/finanzas/efectivo/efectivo.model';
import { EfectivoService } from '../../../services/finanzas/efectivo/efectivo.service';
import { PartnersService } from '../../user/partnersequity/partners/partners.service';
import { PartnersModel } from '../../user/partnersequity/partners/partners.model';
import { BailFormItemComponent } from './bail-form-item.component';
import { AdvancedPaymentLineModel } from '../advancepayment/advancedPaymentline.model';
import { Option } from '../../../shared/models/option.model';

@Component({
    selector: 'convfact-bail-form',
    templateUrl: './bail-form.component.html',
    styleUrls: ['./bail.component.css'],
    standalone: false
})

export class BailFormComponent implements OnInit, AfterContentChecked {
  @Input() bail: BailModel;
  @Output() onSave = new EventEmitter<any>();
  @Input() errors: object;
  @Input() accountsAndTaxes: AccountsAndTaxesModel;
  @Input() concepts: ConceptModel[];
  @Input() bankAccounts: BankAccountModel[] = [];
  @Input() paymentCards: PaymentCardModel[] = [];

  ready: boolean = false;
  bailForm: UntypedFormControl;
  filteredContacts: Observable<ContactModel[]>;
  contactList: ContactModel[] = [];

  aux: number;
  result: number;
  taxes: Array<BailTaxModel>;
  taxesView: string[] = [];

  taxesInvoice: InvoiceTaxesModel[] = [];
  taxesToTheView: string[] = [];

  payMethods = [
    consts.TYPEPAY_CASH,
    consts.TYPEPAY_CREDITCARD_PAY,
    consts.TYPE_DEBITCARD,
    consts.TYPEPAY_DEBITENTRY,
    consts.TYPEPAY_BANKTRANSFERENCE,
    consts.TYPEPAY_CONFIRMING,
    consts.TYPEPAY_PAGARES,
    consts.TYPE_SOCIO,
  ];

  public efectivoList: Efectivo[] = [];
  public sociosList: PartnersModel[] = [];

  total: number = 0
  subtotal: number = 0

  public saved: boolean = false;

  public get payMethodsOptions(): Option[] {
    return this.payMethods.map(method => ({ label: method, value: method }));
  }

  constructor(
    public snackBar: MatSnackBar,
    private contactService: ContactService,
    private taxCalculator: TaxCalculator,
    private efectivoService: EfectivoService,
    private partnersService: PartnersService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
  ) { }

  filterContacts(val) {
    const self = this;
    for (const contact of this.contactList) {
      if (contact.companyName == val) {
        self.bail.providerUid = contact.uid;
      }
    }
    const normalizedValue = this.normalize(val);
    return val ? this.contactList.filter(contact => this.normalize(contact.companyName).includes(normalizedValue)) : this.contactList;
  }

  // Normaliza la cadena eliminando diacríticos y convirtiéndola a minúsculas
  // NFD Descompone la consonante por ejemplo ñ -> n -> ~
  private normalize(str: string): string {
    return str.normalize('NFD').replace(/[\u0300\u0301\u0303\u0327\u0308]/g, '').toLowerCase();
  }

  ngOnInit() {
    this.efectivoService.list()
      .then(listadoEfectivos => {
        this.efectivoList = listadoEfectivos
      })

    this.partnersService.list()
      .then(response => {
        this.sociosList = response
      });

    this.contactList = [];
    this.contactService.getListProviders().then(response => {
      this.contactList = response;
      this.ready = true;
      this.bailForm = new UntypedFormControl();
      this.filteredContacts = this.bailForm.valueChanges
        .pipe(
          map(contact => contact && typeof contact === 'object' ? contact.companyName : contact),
          map(name => this.filterContacts(name))
        );
      this.ready = true;
    });

    this.reCalculate();
  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  save(bail) {
    bail.isInvoice = false;

    bail.fiscalYear = parseInt(ActualSelected.yearSelected);
    bail.activityUid = ActualSelected.activitySelected;

    let noError = true;

    if (!Utils.DateIsInFiscalYear(bail.date)) {
      noError = false;
      this.displayInfo("La fecha y el año fiscal seleccionado, no son el mismo.");
    }

    if (bail.typePay == null || bail.typePay == "") {
      noError = false;
      this.displayInfo("El tipo de pago debe estar especificado.");
    } else {
      if ((bail.typePay == "Transferencia bancaria" || bail.typePay === "Cargo en cuenta"
        || bail.typePay === consts.TYPEPAY_CONFIRMING || bail.typePay === consts.TYPEPAY_PAGARES) &&
        (bail.typePayBankAccount == null || bail.typePayBankAccount == "")) {
        noError = false;
        this.displayInfo("Debe especificar la cuenta bancaria.");
      }
      if (bail.typePay == "Tarjeta de crédito" && (bail.typePayBankAccount == null || bail.typePayBankAccount == "")) {
        noError = false;
        this.displayInfo("Debe especificar la tarjeta de crédito.");
      }
    }

    if (bail.typePay !== consts.TYPEPAY_CASH) {
      bail.efectivoId = null;
    }

    if (bail.typePay !== consts.TYPE_SOCIO) {
      bail.partnersId = 0;
    }

    if (noError) {
      this.preventNullOrEmptyValues(bail);
      this.onSave.emit(bail)
      this.reCalculate();
    }
  }

  preventNullOrEmptyValues(bail) {
    for (let i = 0; i < bail.bailLine.length; i++) {

      if (bail.bailLine[i].discount == null || bail.bailLine[i].discount === '') {
        bail.bailLine[i].discount = 0;
      }
      if (bail.bailLine[i].quantity == null || bail.bailLine[i].quantity === '') {
        bail.bailLine[i].quantity = 0;
      }
      if (bail.bailLine[i].unityAmount == null || bail.bailLine[i].unityAmount === '') {
        bail.bailLine[i].unityAmount = 0;
      }

    }
  }

  // addInvoiceLine() {
  //   this.bail.bailLine.push({ discount: 0, product: '', quantity: 0, taxes: [], unityAmount: 0 });
  //   this.reCalculate();
  // }

  // removeInvoiceLine(invoiceLine) {
  //   this.bail.bailLine.splice(this.bail.bailLine.indexOf(invoiceLine), 1);
  //   if (this.bail.bailLine.length == 0) {
  //     this.bail.bailLine.push({ discount: 0, product: '', quantity: 0, taxes: [], unityAmount: 0 });
  //     this.reCalculate();
  //   }
  // }

  reCalculate() {
    this.calcularTotal();
    this.calcularSubtotal();
  }

  // calcularSubtotal() {
  //   this.subtotal = this.taxCalculator.calcularSubtotal(this.bail);
  // }

  // calcularTotal() {
  //   this.bail.total = this.taxCalculator.calcularTotal(this.bail);
  //   this.total = this.bail.total;
  // }

  // impuestos() {
  //   this.taxesToTheView = this.taxCalculator.impuestos(this.bail, this.result, this.aux, this.taxesView, this.taxesInvoice, this.taxesToTheView);
  //   return this.taxesToTheView;
  // }

  addInvoiceLine() {
    let line = new AdvancedPaymentLineModel();

    const dialog = this.dialog.open(BailFormItemComponent, {
      data: { taxes: this.accountsAndTaxes.taxes, item: line },
    }).afterClosed().subscribe(result => {
      if (result && result.action === 'save') {
        line = result.item;
        this.bail.bailLine.push(line);
      }
      this.cdr.detectChanges();
    });
  }

  removeInvoiceLine(invoiceLine) {
    this.bail.bailLine.splice(this.bail.bailLine.indexOf(invoiceLine), 1);
    if (this.bail.bailLine.length == 0) {
      this.bail.bailLine.push(new AdvancedPaymentLineModel());
    }
  }

  calcularSubtotal() {
    return this.taxCalculator.calcularSubtotal(this.bail);
  }

  calcularTotal() {
    this.bail.total = this.taxCalculator.calcularTotal(this.bail);
    return this.bail.total;
  }

  blColumns = ['product', 'quantity', 'unityAmount', 'discount', 'taxes', 'totalLine', 'actions'];

  impuestos(): string[] {
    return this.taxCalculator.impuestos(this.bail, this.result, this.aux, [], [], []);
  }

  ngAfterContentChecked() {}


  changeToggle(element, other) {
    this.bail[other] = (this.bail[element]);
  }

  toggleEditMode(index) {
    const dialog = this.dialog.open(BailFormItemComponent, {
      data: { taxes: this.accountsAndTaxes.taxes, item: this.bail.bailLine[index] },
    }).afterClosed().subscribe(result => {
      if (result && result.action === 'save') {
        this.bail.bailLine[index] = result.item;
      } else {

      }
      this.cdr.detectChanges();
    });

  }

  calcularTotalesLinea(invoiceLine) {
    invoiceLine.totalLine = this.taxCalculator.calcularTotalLinea(invoiceLine);
    return invoiceLine.totalLine;
  }

  saveLine(index, item) {
    this.bail.bailLine[index] = item;
  }

  getStrTaxes(taxes: any[]) {
    return taxes.map(tax => tax.name).join(', ');
  }

  public trackByIndex(i: number) { return i; }

}
